import datepicker from "js-datepicker";

export default function () {

    if ($('#bookingDate').length > 0) {
        const picker = datepicker('#bookingDate', {
            formatter: (input, date, instance) => {
                const value = date.toLocaleDateString()
                input.value = value // => '1/1/2099'
            },
            minDate: new Date(),
            onSelect: (instance, date) => {
                selectedDate = date.toLocaleDateString("en-US");
                getAvailableRooms(selectedDate);
            }
        });
    }

    let roomData = [];
    let foodData = [];
    let devicesData = [];
    let times = [];
    let selectedRoom = null;
    let selectedDate = '';
    let apiRoot = '/wp-json/spring/v1';

    function getAvailableRooms(date) {
        let termId = $('input[name=term]').val();
        $('.step-1-processing').show();
        $.ajax({
                url: apiRoot + '/rooms',
                type: 'GET',
                data: {
                    term: termId,
                    date: date
                }
            }
        ).done(function (result) {
            if (result) {
                roomData = result;
                renderRooms();
            }
            $('.step-1-processing').hide();
        });
    }

    function getAvailableTimes(roomId) {
        let termId = $('input[name=term]').val();
        $('input[name=selected-room]').val(roomId);
        $('.step-2-processing').show();
        $.ajax({
                url: apiRoot + '/room/available',
                type: 'GET',
                data: {
                    term: termId,
                    room: roomId,
                    date: selectedDate
                }
            }
        ).done(function (result) {
            let timeRanges = result;
            times = timeRanges;
            loadTimeSelection(timeRanges);
            $('input[name=time_selector]').change(function () {
                $('.btn-to-summary').removeAttr('disabled');
            });
            $('.step-2-processing').hide();
        });
    }

    function getFoodsInfo() {
        $.ajax({
                url: apiRoot + '/foods',
                type: 'GET',
                data: {}
            }
        ).done(function (result) {
            if (result) {
                foodData = result;
                renderFoods();
            }
        });
    }

    function getDevicesInfo() {
        $.ajax({
                url: apiRoot + '/devices',
                type: 'GET',
                data: {}
            }
        ).done(function (result) {
            if (result) {
                devicesData = result;
                renderDevices();
            }
        });
    }

    function selectRoom(e) {
        let $btn = $(this);
        let index = $btn.data('id');
        selectedRoom = roomData[index];
        if (selectedRoom != null) {
            let roomId = selectedRoom.id;
            loadRoomInfo(selectedRoom);
            navigateToFormStep(2);
            getAvailableTimes(roomId);
        }

        return false;
    }

    function renderRooms() {
        let html = "";
        for (let i = 0; i < roomData.length; i++) {
            html += renderRoomHtml(roomData[i], i);
        }
        $('.available-rooms').html(html);
        $('.btn-booking-room').click(selectRoom);
    }

    function loadTimeSelection(timeRanges,) {
        let $timeContainer = $('#roomInfoContainer .block-times');
        let html = '';
        let index = 0;
        for (const key in timeRanges) {
            html += renderTimeItem(key, timeRanges[key], index);
            index++;
        }
        $timeContainer.html(html);
    }

    function loadRoomInfo(room) {
        let $container = $('#roomInfoContainer');
        $('.room-image', $container).attr('src', room.image);
        $('.room-name', $container).html(room.name);
        $('.room-description', $container).html(room.description);
        $('input[name=roomPrice]').val(room.price);
        $('input[name=defaultPeoples]').val(room.default_peoples);
        $('.default-people').text(room.default_peoples);
        $('input[name=maxPeoples]').val(room.max_peoples);

        let total = Number(room.price ?? 0) + Number($('input[name=termPrice]').val() ?? 0);

        $('.total-room-person-price .total-price').text(priceFormat(total));
        $('.summary-total-price').text(priceFormat(total));

        let $personPrice = $('input[name=personPrice]');
        $personPrice.val(room.price_extra_person);
        if (room.price_extra_person > 0) {
            $personPrice.closest('.section-price-item').find('.item-price').text(priceFormat(room.price_extra_person));
        }

        let $childPrice = $('input[name=childrenPrice]');
        $childPrice.val(room.price_for_children);
        if (room.price_for_children > 0) {
            $childPrice.closest('.section-price-item').find('.item-price').text(priceFormat(room.price_for_children));
        }
    }

    // Render
    function renderFoods() {
        let html = "";
        for (let i = 0; i < foodData.length; i++) {
            html += renderFoodHtml(foodData[i], i);
        }
        $('.foods-list').html(html);

        $('input[name=food]').change(function () {
            foodPriceUpdate();
        });
    }

    function renderDevices() {
        let html = "";
        let $container = $('.devices-list');
        for (let i = 0; i < devicesData.length; i++) {
            html += renderDeviceHtml(devicesData[i], i);
        }
        $container.html(html);

        $('.number-input .minus', $container).click(function () {
            ($(this).siblings('input[type=number]')[0]).stepDown();
            quantityDeviceUpdated($(this));
            return false;
        });

        $('.number-input .plus', $container).click(function () {
            ($(this).siblings('input[type=number]')[0]).stepUp();
            quantityDeviceUpdated($(this));
            return false;
        });

        $('input.quantity', $container).change(function () {
            quantityDeviceUpdated($(this));
        });
    }

    function renderRoomHtml(room, idx) {
        let html = `<div class='col-12 col-sm-6 col-md-4 col-lg-3'>
                        <div class="room-item">
                            <div class="room-item__image" ><img src='${room.image}'/></div>
                            <div class="room-item__content">
                                 <div class="title">${room.name}</div>
                                 <div class="description">${room.short_description}</div>
                                 <button class='btn btn-primary btn-booking-room' data-id='${idx}'>Booking</button>
                            </div>
                        </div>
                    </div>`;
        return html;
    }

    function renderTimeItem(key, value, index) {
        let booked = key.indexOf('-booked') > 0;
        let itemHtml = `<div class="selector-item ${booked ? 'booked' : ''}">
                            <input type="radio" id="radio${index}" name="time_selector" class="selector-item_radio" value="${key}" ${booked ? 'disabled' : ''}>
                            <label for="radio${index}" class="selector-item_label">${value}</label>
                        </div>`;
        return itemHtml;
    }

    function renderFoodHtml(food, idx) {
        let price = priceFormat(food.price);
        let html = `<div class="row">
                        <div class="col-md-8 col-sm-6 food-info">
                            <div class="food-info__image">
                                <img src="${food.image}"/>
                            </div>
                            <div class="food-info__content">
                                <div class="food-info__content__title">${food.name}</div>
                                <div class="food-info__content__description">${food.description}</div>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-6 food-info-price">
                                 <div class="food-info__price-item">
                                    ${price}
                                 </div>
                                 <div class="food-info__quantity">
                                     <div class="form-group food-selector">
                                            <input type="radio" id="food${idx}" name="food" data-id="${food.id}"
                                                   value="${food.price}" ${(idx == 0 ? "checked" : "")}/>
                                            <label for="food${idx}"></label>
                                        </div>
                                </div>
                                <div class="food-info__total-price">
                                  ${price}
                                </div>
                            </div> 
                        </div>
                    </div>`;
        return html;
    }

    function renderDeviceHtml(device, idx) {
        let price = priceFormat(device.price);
        let html = `<div class="row device-item">
                        <div class="col-lg-7 col-md-6 col-12 device-info">
                            <div class="device-info__image">
                                <img src="${device.image}"/>
                            </div>
                            <div class="device-info__content">
                                <div class="device-info__content__title">${device.name}</div>
                                <div class="device-info__content__description">${device.description}</div>
                            </div>
                        </div>
                        <div class="col-lg-5 col-md-6 col-12 quantity-section-col">
                            <div class="row device-price-item">
                                <div class="col-lg-3 col-4">
                                    <div class="device-price">
                                      ${price}
                                    </div>
                                </div>
                                <div class="col-lg-5 col-4">
                                    <div class="quantity-input">
                                        <div class="number-input">
                                            <button class="minus"></button>
                                            <input aria-label="" class="quantity device-quantity" min="0" data-id="${device.id}" data-price="${device.price}"
                                                   value="0"
                                                   type="number"/>
                                            <button class="plus"></button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-4">
                                    <div class="total-item-price total-device-price">
                                        kr0.00
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>`;
        return html;
    }

    function renderSummaryItems(bookingData) {
        let html = renderSummaryItem(bookingData);
        $('.summary-table').html(html);

        $('.remove-device-item').click(function () {
            let $btn = $(this);
            $.confirm({
                title: "",
                content: "Do you want to remove this device?",
                buttons: {
                    formSubmit: {
                        text: 'Yes',
                        btnClass: 'btn btn-primary',
                        action: function () {
                            removeDevice($btn);
                        }
                    },
                    cancel: function () {
                    }
                }
            });

        });

        $('.remove-food-item').click(function () {
            let $btn = $(this);
            $.confirm({
                title: "",
                content: "Do you want to remove food?",
                buttons: {
                    formSubmit: {
                        text: 'Yes',
                        btnClass: 'btn btn-primary',
                        action: function () {
                            removeFood($btn);
                        }
                    },
                    cancel: function () {
                    }
                }
            });
        });
    }

    function renderSummaryItem(data) {
        let room = data.room;
        let date = data.date;
        let time = times[data.time] ?? '';
        let food = data.food;
        let devices = data.devices;

        let participant = data.peoples + data.children;

        let html = `<div class="order-item"><div class="row">`;
        if (room != undefined) {
            let totalPrice = Number(room.price) + Number($('input[name=termPrice]').val() ?? 0); //+ (room.price_extra_person * data.peoples) + (room.price_for_children * data.children);
            let roomImage = room.image;
            html += `<div class="col-md-3 col-12 room-image"><img src="${roomImage}"/></div>
                        <div class="col-md-9 col-12 order-info">
                            <div class="order-room-info">
                                <div class="order-room-info__date">${date} - ${time}</div>
                                <div  class="row order-room-info__content">
                                    <div class="col-6">
                                        <div class="order-room-info__content__name headline">${room.name}</div>
                                        Antal dellager (<span class="default-peoples">${room.default_peoples}</span>+)
                                        <!--span class="peoples">${participant}</span-->
                                        <br/>
                                        <span class="room-price">${priceFormat(room.price)}</span>
                                    </div>
                                    <div class="col-1 text-end">
                                        <span class="participant">${participant}</span>
                                    </div>
                                    <div class="col-3 text-end">
                                        <span class="total-room-price">${priceFormat(totalPrice)}</span>
                                    </div>
                                    <div class="col-2 text-end">
                                        <span class="room-item-action"></span>
                                    </div>
                                </div>
                        </div>
                    `;
        }

        if (devices.length > 0) {
            for (let i = 0; i < devices.length; i++) {
                let item = devices[i];
                let device = item.device;
                let devicePrice = Number(device.price * item.quantity);
                html += `<div class="order-device-info"><div class="row">
                        <div class="col-6">
                            <div class="order-device-info__headline headline">${device.name}</div>
                            <div class="order-device-info__description">
                                ${device.description}
                            </div>
                        </div>
                        <div class="col-1 text-end">
                        
                        </div>
                        <div class="col-3 text-end">
                            <span class="total-device-price">${priceFormat(devicePrice)}</span>
                        </div>
                        <div class="col-2 text-end">
                          <a class="device-action remove-device-item" data-id="${device.id}"><i class="fa-sharp fa-solid fa-trash"></i></a>
                        </div>
                    </div></div>`;
            }
        }

        if (food != undefined) {
            let foodPrice = (food.price * data.peoples) + (food.price * data.children);
            html += `<div class="order-food-info"><div class="row">
                        <div class="col-6">
                            <div class="order-food-info__headline headline">${food.name}</div>
                            <div class="order-food-info__description">
                                ${food.description}
                            </div>
                        </div>
                        <div class="col-1 text-end">
                            <span class="participant">${participant}</span>
                        </div>
                        <div class="col-3 text-end">
                            <span class="total-food-price">${priceFormat(foodPrice)}</span>
                        </div>
                        <div class="col-2 text-end">
                          <a class="food-action remove-food-item" data-id="${food.id}"><i class="fa-sharp fa-solid fa-trash"></i></a>
                        </div>
                    </div></div>`;
        }

        html += `</div></div></div>`;

        return html;
    }

    function quantityDeviceUpdated($element) {
        let $container = $element.closest('.device-price-item');
        let $quantity = $('.quantity', $container)
        let quantity = Number($quantity.val());
        let price = Number($quantity.data("price") ?? 0);

        let total = quantity * price;

        $('.total-device-price', $container).text(total > 0 ? priceFormat(total) : '');

        totalPriceSummary();
    }

    function quantityPriceUpdated($element) {
        let $container = $element.closest('.section-price-item');
        let $quantity = $('.quantity', $container)
        let quantity = Number($quantity.val());
        let price = $('.item-price-value', $container).val();

        /* let roomPrice = 0;
        if ($quantity.attr('name') == 'personQuantity') {
            roomPrice = Number($('input[name=roomPrice]').val() ?? 0) + Number($('input[name=termPrice]').val() ?? 0);
        }
        let total = roomPrice;
        let defaultQuantity = Number($('input[name=defaultPeoples]', $container).val() ?? 0);

       if (quantity > defaultQuantity) {
            total += (quantity - defaultQuantity) * price;
        }

        $('.total-price', $container).text(priceFormat(total));
        */
        foodPriceUpdate();
        totalPriceSummary();
    }

    function foodPriceUpdate() {
        let foodItems = $('input[name=food]');
        let quantity = 0;
        for (let i = 0; i < $('.section-price-item').length; i++) {
            let $itemContainer = $($('.section-price-item')[i]);
            quantity += Number($('.quantity', $itemContainer).val() ?? 0);
        }
        for (var i = 0; i < foodItems.length; i++) {
            let $ele = $(foodItems[i]);
            let $container = $ele.closest('.food-info-price');
            let $totalPrice = $('.food-info__total-price', $container);
            if ($ele.is(':checked')) {
                let price = Number($ele.val() ?? 0) * quantity;

                $totalPrice.text(priceFormat(price));
            } else {
                $totalPrice.text('');
            }
        }
        totalPriceSummary();
    }

    function totalPriceSummary() {
        let total = 0;
        let totalQuantity = 0;
        total += Number($('input[name=roomPrice]').val() ?? 0) + Number($('input[name=termPrice]').val() ?? 0);

        for (let i = 0; i < $('.section-price-item').length; i++) {
            let $itemContainer = $($('.section-price-item')[i]);
            let quantity = Number($('.quantity', $itemContainer).val());
            let price = Number($('.item-price-value', $itemContainer).val());
            let defaultQuantity = Number($('input[name=defaultPeoples]', $itemContainer).val() ?? 0);
            if (quantity > defaultQuantity) {
                // total += Number((quantity - defaultQuantity) * price);
            }
            totalQuantity += quantity;
        }

        let $devices = $('.device-price-item');
        for (let i = 0; i < $devices.length; i++) {
            let $itemContainer = $($devices[i]);
            let $quantity = $('.quantity', $itemContainer)
            let quantity = Number($quantity.val());
            let price = Number($quantity.data("price") ?? 0);

            total += Number(quantity * price);
        }

        let hasFoods = $('#showFoods').is(":checked");
        if (hasFoods) {
            let selectedFood = $('input[name=food]:checked');
            if (selectedFood.length > 0) {
                let foodPrice = selectedFood.val();
                total += (Number(foodPrice) * totalQuantity);
            }
        }

        $('.summary-total-price').text(isNaN(total) ? '' : priceFormat(total));
    }

    function loadSummary() {
        let data = loadBookingData();

        if (data != null && data != undefined) {
            renderSummaryItems(data);

            let room = data.room;
            let food = data.food;
            let termPrice = data.termPrice;
            let vat = data.vat;
            let devices = data.devices;

            let subTotal = termPrice + roomPrice(room, data.peoples, data.children) + foodPrice(food, data.peoples + data.children) + devicePrice(devices);
            let calculatedVAT = (subTotal * vat / 100);
            let total = subTotal + calculatedVAT;

            let $summaryContainer = $('.booking-summary');
            $('.summary-subtotal', $summaryContainer).text(priceFormat(subTotal));
            $('.summary-vat', $summaryContainer).text(priceFormat(calculatedVAT));
            $('.summary-total', $summaryContainer).text(priceFormat(total));
        }
    }

    // Calculate
    function peoplesPrice(price, participant) {
        return Number(price * participant);
    }

    function roomPrice(room, peoples, children) {
        return Number(room.price); //+ peoplesPrice(room.price_extra_person, peoples) + peoplesPrice(room.price_for_children, children);
    }

    function foodPrice(food, participant) {
        return food == undefined ? 0 : Number(food.price) * Number(participant);
    }

    function devicePrice(deviceItems) {
        let total = 0
        for (let i = 0; i < deviceItems.length; i++) {
            let item = deviceItems[i];
            total += Number(item.device.price * item.quantity);
        }

        return total;
    }

    function priceFormat(price) {
        return 'kr' + Number(price).toFixed(2);
    }

    // Render
    function saveBookingData() {
        let term = Number($('input[name=term]').val());
        let vat = Number($('input[name=VAT]').val())
        let termPrice = Number($('input[name=termPrice]').val() ?? 0)
        let peoples = Number($('input[name=personQuantity]').val());
        let children = Number($('input[name=childrenQuantity]').val());
        let time = $('input[name=time_selector]:checked').val();
        let foodId = '';
        let hasFoods = $('#showFoods').is(":checked");
        let food = undefined;
        if (hasFoods) {
            let selectedFood = $('input[name=food]:checked');
            if (selectedFood.length > 0) {
                foodId = selectedFood.data("id");
                food = foodData.find(f => f.id == foodId);
            }
        }

        let devices = [];
        let $devices = $('.device-price-item');
        for (let i = 0; i < $devices.length; i++) {
            let $itemContainer = $($devices[i]);
            let $quantity = $('.quantity', $itemContainer)
            let quantity = Number($quantity.val());
            let price = Number($quantity.data("price") ?? 0);
            let id = $quantity.data("id")
            if (quantity > 0) {
                let device = devicesData.find(f => f.id == id);
                devices.push({device: device, quantity: quantity});
            }
        }

        let data = {
            "vat": vat,
            "term": term,
            "termPrice": termPrice,
            "date": selectedDate,
            "time": time,
            "room": selectedRoom,
            "peoples": peoples,
            "children": children,
            "food": food,
            "devices": devices
        }

        window.sessionStorage.setItem("booking-data", JSON.stringify(data));
    }

    function loadBookingData() {
        let data = window.sessionStorage.getItem("booking-data");
        if (data != null && data != undefined) {
            let bookingData = JSON.parse(data);

            return bookingData;
        }
        return null;
    }

    function submitBooking($ele) {
        if (validateForm()) {
            let data = getSubmitData();
            $('.page-processing').show();

            $ele.attr('disabled', 'disabled');

            $.ajax({
                    url: apiRoot + '/booking',
                    type: 'POST',
                    data: data
                }
            ).done(function (result) {
                if (result) {
                    $.alert({
                        title: '',
                        content: 'Your order is being processed. We will contact you soon',
                        buttons: {
                            OK: {
                                btnClass: 'btn-primary',
                                action: function () {
                                    window.location.reload();
                                }
                            }
                        }
                    });
                }
                $('.page-processing').hide();
            });
        }
    }

    function getSubmitData() {
        let $container = $('.contact-form-booking-form');
        let firstname = $('input[name=firstname]', $container).val();
        let lastname = $('input[name=lastname]', $container).val();
        let email = $('input[name=email]', $container).val();
        let phone = $('input[name=phone]', $container).val();
        let post_number = $('input[name=post_number]', $container).val();
        let newsletter = $('input[name=newsletter]', $container).is(":checked") ? "true" : "false";
        let bookingInfo = loadBookingData();
        let devices = [];
        if (bookingInfo.devices.length > 0) {
            for (let i = 0; i < bookingInfo.devices.length; i++) {
                let item = bookingInfo.devices[i];
                devices.push({id: item.device.id, quantity: item.quantity});
            }
        }
        return {
            firstname: firstname,
            lastname: lastname,
            email: email,
            phone: phone,
            post_number: post_number,
            newsletter: newsletter,
            type: bookingInfo.term,
            room: bookingInfo.room.id,
            food: bookingInfo.food != undefined ? bookingInfo.food.id : '',
            date: bookingInfo.date,
            time: bookingInfo.time,
            peoples: bookingInfo.peoples,
            children: bookingInfo.children,
            devices: devices
        }
    }

    function removeDevice($ele) {
        let id = $ele.data('id');
        let $container = $ele.closest('.order-device-info');
        $container.remove();
        let $deviceItem = $('.device-price-item input[data-id=' + id + ']');
        $deviceItem.val(0);

        quantityDeviceUpdated($deviceItem);
        saveBookingData();
        loadSummary();
    }

    function removeFood($ele) {
        let id = $ele.data('id');
        let $container = $ele.closest('.order-device-info');
        $container.remove();
        $('.food-selector input[data-id=' + id + ']').removeAttr('checked');

        foodPriceUpdate();
        saveBookingData();
        loadSummary();
    }

    // Validate
    function validateForm() {
        let valid = true;
        let $container = $('.contact-form-booking-form');
        let $email = $('input[name=email]', $container);
        let $phone = $('input[name=phone]', $container);
        let $privacy = $('input[name=policy]', $container);

        let requiredFields = $('input.required', $container);
        for (let i = 0; i < requiredFields.length; i++) {
            let $field = $(requiredFields[i]);

            if ($field.val() == '') {
                setFieldError($field, "The field is required.");
                valid = false;
            } else {
                removeFieldError($field);
            }
        }

        if (!isEmail($email.val())) {
            setFieldError($email, "The email is invalid.");
            valid = false;
        } else {
            removeFieldError($email);
        }

        if (!validatePhoneNumber($phone.val())) {
            setFieldError($phone, "The phone number is invalid.");
            valid = false;
        } else {
            removeFieldError($phone);
        }

        if (valid && !$privacy.is(":checked")) {
            $privacy.focus();
            valid = false;
        }

        return valid;
    }

    function setFieldError($ele, message) {
        let $container = $ele.closest('.form-group');
        $container.addClass('error');
        $('.error-message', $container).text(message);
    }

    function removeFieldError($ele) {
        let $container = $ele.closest('.form-group');
        $container.removeClass('error');
        $('.error-message', $container).text('');
    }

    function isEmail(email) {
        let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(email);
    }

    function validatePhoneNumber(input_str) {
        let re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;

        return re.test(input_str);
    }


    $(document).ready(function () {
        if ($('.booking-area').length > 0) {
            $("html").animate(
                {
                    scrollTop: 0
                },
                150 //speed
            );

            getFoodsInfo();
            getDevicesInfo();

            $('.number-input .minus').click(function () {
                ($(this).siblings('input[type=number]')[0]).stepDown();
                quantityPriceUpdated($(this));
                return false;
            });

            $('.number-input .plus').click(function () {
                ($(this).siblings('input[type=number]')[0]).stepUp();
                quantityPriceUpdated($(this));
                return false;
            });

            $('input.quantity').change(function () {
                quantityPriceUpdated($(this));
            });

            $('.select-booking input').change(function () {
                totalPriceSummary();
            });

            $('#showFoods').click(function () {
                if ($(this).is(':checked')) {
                    $('.foods-list').show();
                    foodPriceUpdate();
                } else {
                    $('.foods-list').hide();
                }
            });

            $('.btn-to-summary').click(function () {
                saveBookingData();
                loadSummary();
                navigateToFormStep(3);
            });

            $('.btn-submit-booking').click(function () {
                submitBooking($(this));
            });
        }
    });

    function moveToTop() {
        $("html").animate(
            {
                scrollTop: $('.site-content').offset().top - 60
            },
            150 //speed
        );
    }

    /**
     * Select all form navigation buttons, and loop through them.
     */
    document.querySelectorAll(".btn-navigate-form-step").forEach((formNavigationBtn) => {
        /**
         * Add a click event listener to the button.
         */
        formNavigationBtn.addEventListener("click", () => {
            /**
             * Get the value of the step.
             */
            const stepNumber = parseInt(formNavigationBtn.getAttribute("step_number"));
            /**
             * Call the function to navigate to the target form step.
             */
            navigateToFormStep(stepNumber);
        });
    });

    let navigateToFormStep = (stepNumber) => {

        document.querySelectorAll(".form-step").forEach((formStepElement) => {
            formStepElement.classList.add("d-none");
        });

        document.querySelectorAll(".form-stepper-list").forEach((formStepHeader) => {
            formStepHeader.classList.add("form-stepper-unfinished");
            formStepHeader.classList.remove("form-stepper-active", "form-stepper-completed");
        });

        document.querySelector("#step-" + stepNumber).classList.remove("d-none");

        const formStepCircle = document.querySelector('li[step="' + stepNumber + '"]');

        formStepCircle.classList.remove("form-stepper-unfinished", "form-stepper-completed");
        formStepCircle.classList.add("form-stepper-active");

        for (let index = 0; index < stepNumber; index++) {

            const formStepCircle = document.querySelector('li[step="' + index + '"]');

            if (formStepCircle) {

                formStepCircle.classList.remove("form-stepper-unfinished", "form-stepper-active");
                formStepCircle.classList.add("form-stepper-completed");
            }
        }
        moveToTop();
    }
}
